/**
 * Truncate title to max length
 * Pure function for string truncation
 */
export const truncateTitle = (title: string, maxLength: number = 35): string => {
  return title.length > maxLength ? title.substring(0, maxLength) + '...' : title;
};
